<template>
    <div>
        <el-select v-model="campaign_id"
                   class="w-full"
                   :placeholder="placeholder"
                   :size="small ? 'small' : ''"
                   :disabled="disabled"
                   default-first-option
                   collapse-tags
                   filterable>
            <el-option-group key="Active Lines"
                             label="Active Lines"
                             v-if="activeCampaignsAlphabeticalOrder && activeCampaignsAlphabeticalOrder.length > 0">
                <el-option
                    v-for="campaign in activeCampaignsAlphabeticalOrder"
                    :key="campaign.id"
                    :label="campaign.name"
                    :value="campaign.id">
                </el-option>
            </el-option-group>
            <el-option-group key="Paused Lines"
                             label="Paused Lines"
                             v-if="pausedCampaignsAlphabeticalOrder && pausedCampaignsAlphabeticalOrder.length > 0">
                <el-option
                    v-for="campaign in pausedCampaignsAlphabeticalOrder"
                    :key="campaign.id"
                    :label="campaign.name"
                    :value="campaign.id">
                </el-option>
            </el-option-group>
        </el-select>
    </div>
</template>

<script>

export default {

    props: {
        placeholder: {
            type: String,
            required: false,
            default: 'Select a sequence'
        },

        company_id: {
            required: true
        },

        value: {
            required: false,
        },

        exclude: {
            required: false,
        },

        small: {
            default: false,
            type: Boolean,
            required: false
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false
        },

        is_fax: {
            type: Boolean,
            required: false,
            default: false
        },

        is_sms: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            campaigns: [],
            campaign_id: this.value
        }
    },

    computed: {
        availableCampaigns() {
            if (this.campaigns) {
                return this.campaigns.filter((campaign) => {
                    return campaign.id != this.exclude
                })
            }

            return []
        },

        campaignsAlphabeticalOrder() {
            if (this.availableCampaigns) {
                let campaigns = _.clone(this.availableCampaigns)
                return campaigns.sort((a, b) => {
                    let textA = a.name.toUpperCase()
                    let textB = b.name.toUpperCase()
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                })
            }

            return []
        },

        activeCampaignsAlphabeticalOrder() {
            if (this.campaignsAlphabeticalOrder.length) {
                let campaigns = _.clone(this.campaignsAlphabeticalOrder)
                return campaigns.filter(campaign => campaign.active == true)
            }

            return []
        },

        pausedCampaignsAlphabeticalOrder() {
            if (this.campaignsAlphabeticalOrder.length) {
                let campaigns = _.clone(this.campaignsAlphabeticalOrder)
                return campaigns.filter(campaign => campaign.active == false)
            }

            return []
        }
    },

    methods: {
        fetchSequences() {
            this.loading = true
            axios.get('/api/admin/sequences', {
                params: {
                    company_id: this.company_id
                }
            })
            .then(res => {
                this.loading = false
                this.campaigns = res.data
            })
            .catch(err => {
                this.loading = false
                this.$root.handleErrors(err.response)
            })
        }
    },

    watch: {
        value() {
            this.campaign_id = this.value
        },

        campaign_id(val) {
            if (this.value !== undefined && this.campaign_id !== this.value) {
                this.$emit('input', val)
            }
        },

        company_id() {
            this.fetchSequences()
        },
    }
}
</script>
